import { FC } from 'react';
import { styled, Typography } from '@mui/material';
import { isToday, isYesterday } from 'date-fns';
import { CalendarTime } from 'further-ui/utils';

const TimestampText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: theme.typography.caption.fontSize,
  marginTop: '-4px',
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
}));

type Props = {
  date: CalendarTime;
  align?: 'left' | 'right';
};

const formatDate = (date: CalendarTime): string => {
  const localDate = date.toLocalDate();
  if (isToday(localDate)) return date.toLabel('--', 'h:mm a');
  if (isYesterday(localDate)) {
    return `Yesterday, ${date.toLabel('--', 'h:mm a')}`;
  }
  return date.toLabel('--', 'MMM d, h:mm a');
};

const Timestamp: FC<Props> = ({ date, align }) => {
  return <TimestampText align={align}>{formatDate(date)}</TimestampText>;
};

export default Timestamp;
